import { $fetch } from 'ofetch'
import type {
  $Fetch,
  NitroFetchRequest,
  NitroFetchOptions,
  TypedInternalResponse,
  ExtractedRouteMethod
} from 'nitropack'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '../stores/authStore'

let initiatedFetch: undefined | $Fetch

export type ApiResponse<
  R extends NitroFetchRequest,
  O extends NitroFetchOptions<R> = NitroFetchOptions<R>
> = TypedInternalResponse<R, unknown, ExtractedRouteMethod<R, O>>

const createAuthedFetch = () => {
  // const config = useAppConfig().hiyieldNuxtLayerFirebaseAuth
  if (!initiatedFetch) {
    initiatedFetch = $fetch.create({
      onRequest: (ctx) => {
        // make some new headers from the ones in options already
        // this makes sure it's always a headers obj we're dealing with
        const headers = new Headers(ctx.options.headers)

        // set the auth header if needed...
        if (!headers.get('Authorization')) {
          // get the idToken
          const authStore = useAuthStore()
          const { idToken } = storeToRefs(authStore)

          // add a new auth header with the id token
          if (idToken) headers.append('Authorization', `Bearer ${idToken.value}`)

          // set the new headers back to the req
          ctx.options.headers = headers
        }

        // onRequest requires us to return a promise for some reason...
        return Promise.resolve()
      },
      onRequestError(ctx) {
        /* @ts-ignore - sentry may not exist on the app, but this will fail silently. */
        if (useNuxtApp()?.$sentry?.captureException) {
          /* @ts-ignore - sentry may not exist on the app, but this will fail silently. */
          useNuxtApp()?.$sentry?.captureException(ctx.error, {
            extra: { req: ctx.request, rest: ctx.response }
          })
        }
      },
      retry: useAppConfig().hiyieldNuxtLayerFirebaseAuth.authedFetchRetryAmount
    })
  }

  return initiatedFetch
}

export const $authedFetch = () => ({ fetch: createAuthedFetch() })
